'use client';

import React from 'react';

// eslint-disable-next-line boundaries/element-types
import { LoginForm } from '@features/auth';
import styles from './product-reviews.module.css';

interface AuthRequiredModalProps {
  locale: {
    REVIEWS_AUTH_REQUIRED_MESSAGE?: string;
    PAGE_PERSONAL_SIGN_IN?: string;
    PAGE_PERSONAL_SIGN_IN_LOGIN?: string;
    PAGE_PERSONAL_SIGN_IN_LOGIN_PH?: string;
    PAGE_PERSONAL_SIGN_IN_PASS?: string;
    PAGE_PERSONAL_SIGN_IN_PASS_PH?: string;
    PAGE_PERSONAL_SIGN_IN_BTN?: string;
    PAGE_PERSONAL_SIGN_IN_ERROR?: string;
    PAGE_PERSONAL_SIGN_SOCIAL_AUTH?: string;
    PAGE_PERSONAL_REGISTRATION?: string;
    PAGE_PERSONAL_REGISTRATION_TITLE?: string;
    PAGE_PERSONAL_REGISTRATION_MAIL?: string;
    PAGE_PERSONAL_REGISTRATION_MAIL_PH?: string;
    PAGE_PERSONAL_REGISTRATION_PASS?: string;
    PAGE_PERSONAL_REGISTRATION_PASS_2?: string;
    PAGE_PERSONAL_REGISTRATION_PASS_PH?: string;
    PAGE_PERSONAL_REGISTRATION_PASS_ERROR?: string;
    PAGE_PERSONAL_REGISTRATION_SUCCESS?: string;
    PAGE_PERSONAL_REGISTRATION_SUCCESS_TEXT?: string;
    PAGE_PERSONAL_REGISTRATION_SUCCESS_BTN?: string;
    PAGE_PERSONAL_REGISTRATION_ERROR?: string;
    PAGE_PERSONAL_REGISTRATION_BTN?: string;
    PAGE_PERSONAL_RECOVER_PASS?: string;
    PAGE_PERSONAL_RECOVER_PASS_TITLE?: string;
    PAGE_PERSONAL_RECOVER_PASS_MAIL?: string;
    PAGE_PERSONAL_RECOVER_PASS_MAIL_PH?: string;
    PAGE_PERSONAL_RECOVER_PASS_BTN?: string;
    PAGE_PERSONAL_RECOVER_PASS_SUCCESS?: string;
    PAGE_PERSONAL_RECOVER_PASS_SUCCESS_TEXT?: string;
    PAGE_PERSONAL_RECOVER_PASS_SUCCESS_BTN?: string;
    PAGE_PERSONAL_RECOVER_PASS_ERROR?: string;
  };
  onClose?: () => void;
  onAuthSuccess?: () => void;
}

// Специальная форма входа для модалки отзывов, которая не делает редирект
const ReviewsLoginForm = ({ locale, onClose, onAuthSuccess }: AuthRequiredModalProps) => {
  const handleAuthSuccess = () => {
    onAuthSuccess?.();
    onClose?.();
  };

  return (
    <LoginForm 
      locale={locale} 
      onClose={onClose}
      onAuthSuccess={handleAuthSuccess}
      disableReg={false}
    />
  );
};

export const AuthRequiredModal = ({ locale, onClose, onAuthSuccess }: AuthRequiredModalProps) => {
  return (
    <div className={styles.authRequiredContent}>
      <p className={styles.authRequiredMessage}>
        {locale.REVIEWS_AUTH_REQUIRED_MESSAGE || 'Для написания отзыва необходимо войти в аккаунт'}
      </p>
      <ReviewsLoginForm locale={locale} onClose={onClose} onAuthSuccess={onAuthSuccess} />
    </div>
  );
}; 